import $ from "jquery";

const cardSlider = function () {
    const $container = $("#card-slider");
    const $slides = $container.find(".slide");
    const $pagination = $container.find(".pagination");
    const $text = $container.find(".slide__text");

    // Get sample from the first image
    let $img = $("#card-slider .active").find(".slide__img");

    if (!$img) return;
    const paginationStyle = {
        position: "absolute",
        top: $img.offset().top,
        left: "50%",
        transform: "translateX(-50%)",
        "z-index": "999",
    };

    $pagination.css(paginationStyle);
    $text.css("margin-top", $pagination.outerHeight() + 20);
};

export { cardSlider };
